import { action } from "../../../utils/actions";

export const OPEN_NATIONAL_SOCIETY_DASHBOARD = action(
  "OPEN_NATIONAL_SOCIETY_DASHBOARD",
);
export const GET_NATIONAL_SOCIETY_DASHBOARD_DATA = action(
  "GET_NATIONAL_SOCIETY_DASHBOARD_DATA",
);
export const GET_NATIONAL_SOCIETY_DASHBOARD_REPORT_HEALTH_RISKS = action(
  "GET_NATIONAL_SOCIETY_DASHBOARD_REPORT_HEALTHRISKS",
);
export const GENERATE_NATIONAL_SOCIETY_PDF = action(
  "GENERATE_NATIONAL_SOCIETY_PDF",
);
